import { UFOExperience, ExperienceTypes, ExperiencePerformanceTypes } from '@atlassian/ufo';
import { createJpdExperience } from '../../utils/experience/main.tsx';

export const pageLoad = createJpdExperience(
	new UFOExperience('jpd.global-fields-administration', {
		type: ExperienceTypes.Load,
		performanceType: ExperiencePerformanceTypes.PageLoad,
	}),
);

export const globalFieldCreate = createJpdExperience(
	new UFOExperience('jpd.global-fields-administration.field-create', {
		type: ExperienceTypes.Experience,
		performanceType: ExperiencePerformanceTypes.InlineResult,
	}),
);

export const globalFieldDelete = createJpdExperience(
	new UFOExperience('jpd.global-fields-administration.field-delete', {
		type: ExperienceTypes.Experience,
		performanceType: ExperiencePerformanceTypes.InlineResult,
	}),
);

export const globalFieldAssociate = createJpdExperience(
	new UFOExperience('jpd.global-fields-administration.field-associate', {
		type: ExperienceTypes.Experience,
		performanceType: ExperiencePerformanceTypes.InlineResult,
	}),
);

export const globalFieldUnassociate = createJpdExperience(
	new UFOExperience('jpd.global-fields-administration.field-unassociate', {
		type: ExperienceTypes.Experience,
		performanceType: ExperiencePerformanceTypes.InlineResult,
	}),
);

export const globalFieldCheckViewsUsage = createJpdExperience(
	new UFOExperience('jpd.global-fields-administration.field-check-views-usage', {
		type: ExperienceTypes.Experience,
		performanceType: ExperiencePerformanceTypes.InlineResult,
	}),
);

export const globalFieldUpdate = createJpdExperience(
	new UFOExperience('jpd.global-fields-administration.field-update', {
		type: ExperienceTypes.Experience,
		performanceType: ExperiencePerformanceTypes.InlineResult,
	}),
);

export const globalFieldUpdateConfig = createJpdExperience(
	new UFOExperience('jpd.global-fields-administration.field-update-config', {
		type: ExperienceTypes.Experience,
		performanceType: ExperiencePerformanceTypes.InlineResult,
	}),
);

export const globalFieldCheckProjectUsage = createJpdExperience(
	new UFOExperience('jpd.global-fields-administration.field-check-project-usage', {
		type: ExperienceTypes.Experience,
		performanceType: ExperiencePerformanceTypes.InlineResult,
	}),
);

export const loadGlobalFields = createJpdExperience(
	new UFOExperience('jpd.global-fields-administration.load-fields', {
		type: ExperienceTypes.Experience,
		performanceType: ExperiencePerformanceTypes.InlineResult,
	}),
);

export const loadGlobalLabels = createJpdExperience(
	new UFOExperience('jpd.global-fields-administration.load-global-labels', {
		type: ExperienceTypes.Experience,
		performanceType: ExperiencePerformanceTypes.InlineResult,
	}),
);

export const loadJpdProjects = createJpdExperience(
	new UFOExperience('jpd.global-fields-administration.load-jpd-projects', {
		type: ExperienceTypes.Experience,
		performanceType: ExperiencePerformanceTypes.InlineResult,
	}),
);

export const loadProjectsWithField = createJpdExperience(
	new UFOExperience('jpd.global-fields-administration.load-projects-with-field', {
		type: ExperienceTypes.Experience,
		performanceType: ExperiencePerformanceTypes.InlineResult,
	}),
);

export const fieldAddOptions = createJpdExperience(
	new UFOExperience('jpd.global-fields-administration.field-add-options', {
		type: ExperienceTypes.Experience,
		performanceType: ExperiencePerformanceTypes.InlineResult,
	}),
);

export const fieldDeleteOption = createJpdExperience(
	new UFOExperience('jpd.global-fields-administration.field-delete-option', {
		type: ExperienceTypes.Experience,
		performanceType: ExperiencePerformanceTypes.InlineResult,
	}),
);

export const fieldRenameOption = createJpdExperience(
	new UFOExperience('jpd.global-fields-administration.field-rename-option', {
		type: ExperienceTypes.Experience,
		performanceType: ExperiencePerformanceTypes.InlineResult,
	}),
);

export const fieldMoveOptions = createJpdExperience(
	new UFOExperience('jpd.global-fields-administration.field-move-options', {
		type: ExperienceTypes.Experience,
		performanceType: ExperiencePerformanceTypes.InlineResult,
	}),
);

export const copyValues = createJpdExperience(
	new UFOExperience('jpd.global-fields-administration.copy-values', {
		type: ExperienceTypes.Experience,
		performanceType: ExperiencePerformanceTypes.InlineResult,
	}),
);
